/**
 * Loại lỗi ghi sổ
 * NNLINH 15.07.2022
 */
export default {
    // Lỗi
    // Hiển thị thông báo và dừng lại
    Error: 0,
    // Cảnh báo ấn OK
    Warning: 1,
    // Hiển thị confirm yes/no
    Question: 2,
    // Lỗi phát sinh dữ liệu
    Generation: 3,
}